module.exports = __webpack_public_path__ + "media/images/JemTheMovie/web_jem_logo_400-1f28de3687625ba97e3c2303556bcb24.png";